/**
 * Scroll to the current URL hash target, or to the top if none.
 * Prefer GSAP ScrollSmoother when an instance is provided / available.
 */
export function getHashElement(
  hash: string = typeof window !== "undefined" ? window.location.hash : "",
): HTMLElement | null {
  if (!hash || hash === "#") return null;

  try {
    return document.querySelector<HTMLElement>(hash);
  } catch {
    return null;
  }
}

export function scrollToHashOrTop(options?: {
  /** Existing ScrollSmoother instance, if already created */
  smoother?: { scrollTo: (target: unknown, smooth?: boolean, position?: string) => void } | null;
  /** Instant vs smooth native scroll */
  behavior?: ScrollBehavior;
  /** Offset used with ScrollSmoother position string */
  headerOffsetPx?: number;
}): boolean {
  if (typeof window === "undefined") return false;

  const headerOffsetPx = options?.headerOffsetPx ?? 100;
  const el = getHashElement();

  if (!el) {
    if (options?.smoother) {
      options.smoother.scrollTo(0, false);
    } else {
      window.scrollTo(0, 0);
    }
    return false;
  }

  if (options?.smoother) {
    options.smoother.scrollTo(el, false, `top top+=${headerOffsetPx}`);
    return true;
  }

  const top = el.getBoundingClientRect().top + window.scrollY - headerOffsetPx;
  window.scrollTo({ top: Math.max(0, top), behavior: options?.behavior ?? "auto" });
  return true;
}
